export const CURTAIN_RAISER_FREQUENCY_FLAG_TIMEOFFSET_MS = 3 * 60 * 60 * 1000; // 3 hours

export const CURTAIN_RAISER_ERROR = {
    HEADING: "Internet Connection Issue",
    DESCRIPTION: "Please try again",
    CTA_TEXT: "Retry",
};
